import React, { useEffect, useRef, useMemo, useState } from "react";
import { Box, Typography, Button, Grid, Paper } from "@mui/material";
import QuestionButton from "./QuestionButton";
import { useQuestionNavigatorGate } from "../../../hooks/useQuestionNavigatorGate";
// import { leftTime } from "../../../components/TimerComponent";
import useQuestionSidebarStyles from "../testStyle/gateStyle/questionSidebarStyle";
import { useProfile } from "../../../context/ProfileContext";
import { useQuestionSection } from "../../../hooks/default/useQuestionSection";
import FinalSubmissionDialog from "../../../components/popups/FinalSubmissionDialog";
import avt from "../../../images/userAvatar.png";
import { useTimeLeft } from "../../../context/TimeLeftContext";

const QuestionSidebar = ({
  questionData,
  currentQuestion,
  setCurrentQuestion,
  subjectId,
  activeSectionId,
  activeSubjectId,
  setIsOnSubmit,
  mobileOpen,
  isMobile,
  onClose,
}) => {
  const classes = useQuestionSidebarStyles(); // Use the styles
  const {
    questions,
    answered,
    marked,
    notVisited,
    notAnswered,
    markedWithAnswered,
  } = useQuestionNavigatorGate({
    questionData,
    currentQuestion,
    activeSectionId,
    activeSubjectId,
  });

  const [enabledSubmit, setEnabledSubmit] = useState(false);
  const { timeLeft } = useTimeLeft()

  const filteredQuestions = useMemo(() => {
    return (
      questionData?.filter((q) => {
        try {
          return (
            q &&
            Number(q?.section_id) === Number(activeSectionId) &&
            Number(q?.subject_id) === Number(activeSubjectId)
          );
        } catch (error) {
          return false;
        }
      }) || []
    );
  }, [questionData, activeSectionId, activeSubjectId]);

  const {
    handleOpenSubmitModal,
    stats,
    handleFinalSubmitCheck,
    finalSubmitChecked,
    countdownTime,
    submitError,
    handleCloseSubmitModal,
    showSubmitModal,
    handleFinalSubmit,
    handleSaveNextDefault,
    isTimeUp,
    handleDClick,
  } = useQuestionSection({
    questionData: filteredQuestions,
    currentQuestion,
    setCurrentQuestion,
    subjectId,
    activeSectionId,
    activeSubjectId,
  });

  const { profile } = useProfile();
  const boxRef = useRef(null);
  const questionRefs = useRef([]);

  const statuses = [
    {
      label: "Answered",
      color: "#4CAF50",
      number: answered || 0,
      type: "attempted",
    },
    {
      label: "Not Answered",
      color: "#FF5722",
      number: notAnswered || 0,
      type: "notAnswered",
    },
    { label: "Marked", color: "#9C27B0", number: marked, type: "marked" },
    {
      label: "Not Visited",
      color: "#BDBDBD",
      number: notVisited || 0,
      type: "notVisited",
    },
    {
      label: "Answered and Marked for Review",
      color: "#9C27B0",
      number: markedWithAnswered || 0,
      check: true,
      type: "markedWithAnswered",
    },
    // {
    //   label: "Current Question",
    //   color: "#BDBDBD",
    //   number: currentQuestion + 1,
    //   type: "active",
    // },
  ];

  function timeToMinutes(timeStr) {
    const [hours, minutes, seconds] = timeStr.split(":").map(Number);
    return hours * 60 + minutes + seconds / 60;
  }

  const isEnabledSubmit = () => {
    const remainingTime = timeToMinutes(timeLeft || "00:00:00");
    const duration = Number(
      timeToMinutes(sessionStorage.getItem("examDuration") || "00:00:00")
    );
    const timeLoss = duration - remainingTime;
    const enable_submit = Number(sessionStorage.getItem("enable_submit"));
    return timeLoss >= enable_submit;
  };

  // useEffect(() => {
  //   if (leftTime && sessionStorage.getItem('userId')!=='4660') {
  //     setEnabledSubmit(isEnabledSubmit());
  //   }
  //   if(sessionStorage.getItem('userId')==='4660'){
  //     setEnabledSubmit(sessionStorage.getItem('userId')==='4660');
  //   }
  // }, [leftTime]);

  useEffect(() => {
    const checkSubmitStatus = () => {
      const userId = sessionStorage.getItem("userId");
      const alreadyClicked = sessionStorage.getItem("alreadyClicked");

      let enable = false;

      if (userId === "4660") {
        enable = true;
      } else if (alreadyClicked) {
        enable = true;
      } else if (timeLeft) {
        enable = isEnabledSubmit();
      }

      setEnabledSubmit(enable);
    };

    // Immediate check
    checkSubmitStatus();

    // Continuous interval
    const interval = setInterval(checkSubmitStatus, 2000);

    document.addEventListener("visibilitychange", checkSubmitStatus);

    return () => {
      clearInterval(interval);
      document.removeEventListener("visibilitychange", checkSubmitStatus);
    };
  }, [timeLeft]); // include dependency for reliability


  // Scroll to current question when it changes
  useEffect(() => {
    if (
      currentQuestion >= 0 &&
      questionRefs.current[currentQuestion] &&
      boxRef.current
    ) {
      const questionElement = questionRefs.current[currentQuestion];
      const boxElement = boxRef.current;

      // Calculate positions
      const boxRect = boxElement.getBoundingClientRect();
      const questionRect = questionElement.getBoundingClientRect();

      // Calculate scroll position
      const scrollPosition =
        questionRect.top -
        boxRect.top +
        boxElement.scrollTop -
        boxRect.height / 2 +
        questionRect.height / 2;

      // Smooth scroll
      boxElement.scrollTo({
        top: scrollPosition,
        behavior: "smooth",
      });
    }
  }, [currentQuestion]);

  return (
    <Paper
      elevation={3}
      className={`${classes.rootPaper} ${!mobileOpen || !isMobile
        ? classes.rootHeightHaf
        : classes.rootHeightFull
        }`}
    >
      {/* Fixed Top Section */}
      <Box className={classes.topSection}>
        <Box
          style={{
            // gap: "10px",
            display: "flex",
            alignItem: "center",
            padding: "10px",
          }}
        >
          <div className={classes.profileImagecontainer}>
            <img
              src={profile?.image_url ? profile?.image_url : avt}
              alt="Profile IMG"
              className={classes.profileImage}
              onError={({ currentTarget }) => {
                currentTarget.onerror = null;
                currentTarget.src = "userAvatar.png";
              }}
            />
          </div>
          <Box
            style={{
              display: "flex",
              flexDirection: "column",
              // justifyContent: "center",
            }}
          >
            {/* <Typography
              variant="body1"
              fontWeight={"bold"}
              className={classes.timeText}
            >
              Time Left:{" "}
              <span style={{ color: "black" }}>
                <TimerComponent setIsTimeUp={setIsTimeUp} />
              </span>
            </Typography>
            <Typography variant="subtitle1" mt="-8px">
              Welcome Test Preview
            </Typography> */}
            <Typography variant="h6" fontWeight={"bold"}>
              {profile?.full_name}
            </Typography>
          </Box>
        </Box>

        {/* Status legend */}
        <Grid container spacing={1} className={classes.statusLegendGrid}>
          {statuses.map((status, index) => (
            <Grid item xs={index === statuses.length - 1 ? 12 : 6} key={index}>
              <Box className={classes.statusItem}>
                <QuestionButton number={status.number} type={status.type} />
                <Typography variant="body2">{status.label}</Typography>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Box>

      {/* Scrollable Questions Palette */}
      <Box className={classes.questionsPalette}>
        <div>
          <Typography variant="body1" className={classes.paletteHeader}>
            Questions Palette
          </Typography>
          <div
            style={
              {
                // height: "calc(100vh - 350px)",
                // height: "100%",
                // overflowY: "scroll",
                // "::-webkit-scrollbar": { display: "none" },
              }
            }
          >
            <Typography variant="body2" className={classes.chooseQuestionText}>
              Choose a Question
            </Typography>
            <Grid
              container
              spacing={1}
              className={classes.questionGrid}
              ref={boxRef}
            >
              {questions
                ?.filter(
                  (q) =>
                    Number(q.section_id) === Number(activeSectionId) &&
                    Number(q.subject_id) === Number(activeSubjectId)
                )
                .map((question, idx) => (
                  <Grid
                    item
                    xs={3}
                    sm={2}
                    md={2}
                    key={question.number}
                    ref={(el) => (questionRefs.current[idx] = el)}
                  >
                    <Box
                      className={classes.questionItem}
                      onClick={() => {
                        if (currentQuestion === idx) return;
                        const q = questionData?.filter(
                          (q) =>
                            Number(q.section_id) === Number(activeSectionId) &&
                            Number(q.subject_id) === Number(activeSubjectId)
                        )[idx];
                        const status = questions?.filter(
                          (q) =>
                            Number(q.section_id) === Number(activeSectionId) &&
                            Number(q.subject_id) === Number(activeSubjectId)
                        )[idx].status;
                        setCurrentQuestion(idx);
                        handleDClick(q, status, idx);
                        if (isMobile && onClose) {
                          onClose();
                        }
                      }}
                    >
                      <QuestionButton
                        // number={question.number}
                        number={idx + 1}
                        type={question.status}
                        height={40}
                        width={40}
                      />
                    </Box>
                  </Grid>
                ))}
            </Grid>
          </div>
        </div>

        <Box
          style={{
            position: "sticky",
            bottom: 0,
            padding: "16px",
            display: "flex",
            justifyContent: "center",
            borderTop: "2px solid black",
            backgroundColor: "#E3F2FD",
          }}
        >
          <Button
            variant="contained"
            sx={{
              borderRadius: "0px",
              backgroundColor: "#337ab7",
              "&:hover": { backgroundColor: "#286090" },
            }}
            disabled={!enabledSubmit}
            onClick={() => {
              setIsOnSubmit(true);
              sessionStorage.setItem("isOnsubmit", true);
              sessionStorage.setItem("alreadyClicked", true);
            }}
          >
            Submit
          </Button>
        </Box>
      </Box>

      <FinalSubmissionDialog
        open={showSubmitModal || isTimeUp}
        onClose={handleCloseSubmitModal}
        onSubmit={handleFinalSubmit}
        isTimeUp={isTimeUp}
        stats={stats}
        submitError={submitError}
        countdownTime={countdownTime}
        finalSubmitChecked={finalSubmitChecked}
        onFinalSubmitCheck={handleFinalSubmitCheck}
      />
    </Paper>
  );
};

export default QuestionSidebar;
